import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectMarketYoyGrowthExpectations = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.planningDetails
)
